import React, { Component } from 'react'

import { CrfContext } from "../../CrfContext";

import SideNav from "../sidenav/Sidenav";
import { Link } from 'react-router-dom';

import './Drafts.css'

import axios from 'axios'

export class Drafts extends Component {
    // state ={
    //     approvedRequest: false,
    //     allRequests: []
    // }

    state = {

        approvedRequest: false,
        allRequests: [],
        showBanner: true,
        showForm: false,
        showPage1: false,
        showPage2: false,
    
        vendor: '',
        vendorError: false,
        vendorErr: 1,
        particulars: '',
        particularsError: false,
        particularsErr: 1,
        requestingDepartment: "",
        poNumber: 1,
        poNumberError: false,
        poNumberErr: 1,
        project: '',
        projectError: false,
        projectErr: 1,
        subProject: '',
        file: null,
        fileError: false,
        fileErr: 1,
        
        projectClass: [
            {
              glCategory: "",
              glAccount: "",
              description1: "",
              description2: "",
              itemNumber: "",
              grossPricePerItem: 0,
              netPricePerItem: 0,
              quantity: 1,
              costType: "1OV",
              vatType: "",
              vatTypeValue: 1,
              wTax: 0,
              wTaxType:"X1",
              wTaxTypeValue: 0,
              wTaxTypeString: "",
              unitPrice: 0,
              subNetPrice: 0,
              projectClass: ""
          },
        ],
        glCategory: "",
        projectCode: '',
        vendorLists: [],
        departmentLists: [],
        projectLists: [],
        projectCode: "",
        accountTypes: [],
        itemNoList:[],
    
        redirect: false,
        crfId: "",
    
    vendorListEmpty: false,
    updateForm: false,
    advancesProjectClass: [],
    
    subNetList: [],
    
    vatTypeSelector: "",
    vatTypeSelected: "",
    
    wTaxRates: [],
    
    vendorLists: [],
    projectLists: [],
    
    error: 0,
    
    removal: false,
    target: null,
    addProjectClass: false,
    
    }

    componentDidMount(){
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/status/saved`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response.data.data)
              
              
              if(response.data.data === "Draft is only available for Requestor Accounts"){
                  this.setState({
                    allRequests: [{
                        requestType: "Draft is Empty"
                    }]
                  })
              }else{
                this.setState({
                    allRequests: response.data.data
                  })
              }
            //   console.log(this.state.myRequests)
          })
          .catch(error => {
              console.log(error.response)   
            })
    }
    formatDate = (date) => {
        if(date){
            return `${date.split(' ')[1]} ${date.split(' ')[2]} ${date.split(' ')[3]} ${date.split(' ')[4]}`
        }else{
            return ""
        }
    }
    render() {
        console.log(this.state.allRequests)
        let allRequests = this.state.allRequests

        if(this.state.allRequests.length === 0){
            allRequests = [{}]
        }
        return (
            <CrfContext.Consumer>
      {(context) => (
          <div id="mainPage">
          <div id="sidePanel">
            <SideNav 
              testState = {context.state.testState}
              toggleBtn1List = {context.toggleBtn1List}
              toggleBtn2List = {context.toggleBtn2List}
              btn1List = {context.state.btn1List}
              btn2List = {context.state.btn2List}
              userRole = {context.state.userRole}
            />
          </div>
          <div id="mainPanel">
            <div className="requestSelectionPanel">
                    <div className="toApproveHeader">
                        <div>
                            <h1>Drafts</h1>
                        </div>
                        {/* TABLE HEAD */}
                        <div className="myRequestTableHeader">
                            <div className="draftTHead">
                                <h4>Request type</h4>
                            </div>
                            <div className="draftTHead">
                                <h4>Vendor name</h4>
                            </div>
                            <div className="draftTHead">
                                <h4>Date modified</h4>
                                {/* <h6 className="tHeadText">Expected</h6>
                                <h6 className="tHeadText">Completion Date</h6> */}
                            </div>
                        </div>
                        {/*END TABLE HEAD */}
                    </div>
                </div>
                {/* TABLE DATA */}
            <div className="divisionToApprove">

            </div>
            {true ? 
                <>
                     {this.state.allRequests.map(requestsArray => 
                <>
                    {requestsArray.requestType !== "Draft is Empty" ? 
                        <Link style={link} to={`/Draft/${requestsArray._id}`}>
                        <div className="tableData">
                            <div className="draftTData">
                                <h4>{requestsArray.requestType}</h4>
                            </div>
                            <div className="tDataVendor">
                                {requestsArray.vendor ? <h4>{requestsArray.vendor}</h4> : null }
                                
                                {/* <h4>{(requestsArray.creationDate).slice(4,21)}</h4> */}
                            </div>
                            <div className="draftTData">
                                {this.formatDate(requestsArray.creationDate)}
                            </div>
                        </div>
                        </Link>
                    :null}
                </>
            )}
                </>
            :null}
            
            </div>
        </div>

      )}
    </CrfContext.Consumer>
        )
    }
}

const link ={
    textDecoration: "none",
    color: "black"
}

export default Drafts
